var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 5H11.6667V6.66667H12.5H16.3215L10.8333 12.1548L6.42259 7.74408L5.83333 7.15482L5.24408 7.74408L0.660743 12.3274L0.0714874 12.9167L1.25 14.0952L1.83925 13.5059L5.83333 9.51184L10.2441 13.9226L10.8333 14.5118L11.4226 13.9226L17.5 7.84518V11.6667V12.5H19.1667V11.6667V5.83333V5H18.3333H12.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/trend-up.e7d170a74b5408d8f7dfb8ec2ad87d53.svg";
export { ForwardRef as ReactComponent };